export const purposeOption = [
    {
        label: "销售",
        value: "销售"
    },
    {
        label: "样机",
        value: "样机"
    },
    {
        label: "售后换机",
        value: "售后换机"
    },
]

export const oqcProblemOption = [
    {
        label: "缺少配件",
        value: "缺少配件",
    },
    {
        label: "外观",
        value: "外观",
    },
    {
        label: "其他",
        value: "其他",
    },
]

// 设置渲染数据
export const setmediaInfo = (list) => {
    if (!list) return;
    list.forEach((item) => {
        if (
            item.inspectionIssues &&
            item.inspectionIssues.indexOf("[") !== -1
        ) {
            const list = JSON.parse(item.inspectionIssues);
            if (typeof list === "object")
                list.forEach((issues, index) => {
                    item[`issuesDesc${index + 1}`] = [];
                    item[`issuesImg${index + 1}`] = [];
                    item[`issuesVideo${index + 1}`] = [];
                    item[`questionType${index + 1}`] = [];
                    item[`solution${index + 1}`] = [];
                    item[`reason${index + 1}`] = [];
                    issues.list.forEach((media) => {
                        item[`issuesImg${index + 1}`].push(
                            ...JSON.parse(media.picture)
                        );
                        item[`issuesVideo${index + 1}`].push(
                            ...JSON.parse(media.video)
                        );
                        item[`questionType${index + 1}`].push(media.type);
                        item[`issuesDesc${index + 1}`].push(media.desc);
                        item[`solution${index + 1}`].push(media.solution);
                        item[`reason${index + 1}`].push(media.reason);
                    });
                    item[`inspectionPersonnel${index + 1}`] =
                        issues.inspectionPersonnel;
                    item[`qualityPersonnel${index + 1}`] = issues.qualityPersonnel;
                });
        }
    });
};
